/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { types } from "./actions";

const initialState = {
  isLoggedIn: false,
  loggingIn: false,
  error: null,
  user: null,
  change_password_response: null,
  reset_password_response: null,
  forgot_response: null,
  userDetails: {
    email: "",
    user: "",
    company_name: "",
    company_check: true,
  },
  redirectPendingUser: null,
  successResponse: null,
  companyName: null,
  cardAddResponse: null,
  cardAddError: null,
  cardLoading: false,
  cardData: null,
  fetchCardError: null,
  loadingApi: false,
  loadedApi: true,
  socialLogin: false,
  refreshHelpSiteSuccessMsg: null,
  refreshHelpSiteErrorMsg: null,
  isLoaded: false,
  ssoDetails: null,
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_LOGIN:
      return {
        ...state,
        loggingIn: true,
        error: null,
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        loggingIn: false,
        isLoggedIn: true,
        user: action.payload,
      };
    case types.LOG_OUT_SUCCESS:
      return {
        ...initialState,
      };
    case types.LOGIN_ERROR:
      return {
        ...state,
        loggingIn: false,
        user: null,
        error: action.payload,
      };
    case types.FORGOT_PASSWORD:
      return {
        ...state,
        loadingApi: true,
        loadedApi: false,
        error: null,
      };
    case types.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loadingApi: false,
        loadedApi: true,
        forgot_response: action.payload,
        error: null,
      };

    case types.FORGOT_PASSWORD_REJECTED:
      return {
        ...state,
        loadingApi: false,
        loadedApi: true,
        error: action.payload,
        forgot_response: null,
      };
    case types.CHANGE_PASSWORD:
      return {
        ...state,
        error: null,
      };
    case types.CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        change_password_response: action.payload,
      };
    case types.CHANGE_PASSWORD_REJECTED:
      return {
        ...state,
        loading: false,
        change_password_response: action.payload,
      };
    case types.REMOVE_CHANGE_PASS_RESPONSE:
      return {
        ...state,
        loading: false,
        change_password_response: null,
      };
    case types.RESET_PASSWORD:
      return {
        ...state,
      };
    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        reset_password_response: action.payload,
      };

    case types.RESET_PASSWORD_REJECTED:
      return {
        ...state,
        loading: false,
        reset_password_response: action.payload,
      };
    case types.SIGNUP_USER: {
      return {
        ...state,
        successResponse: null,
        error: null,
        loading: true,
        loaded: false,
      };
    }
    case types.SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.SIGNUP_USER_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        ...(process.env.REACT_APP_ENABLE_SSO === "true"
          ? { error: action.payload }
          : { successResponse: action.payload }),
      };
    }
    /* istanbul ignore next */
    case types.COMPLETE_SIGNUP: {
      return {
        ...state,
        loading: true,
        loaded: false,
        successResponse:
          action.payload.companyCheck === false ? "processing" : null,
      };
    }
    /* istanbul ignore next */
    case types.COMPLETE_SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        successResponse: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.COMPLETE_SIGNUP_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    }
    /* istanbul ignore next */
    case types.REDIRECT_PENDING_USER: {
      return {
        ...state,
        redirectPendingUser: true,
        companyName: action.payload,
      };
    }
    case types.CARD_ADD: {
      return {
        ...state,
        cardAddError: null,
        cardAddResponse: null,
        cardLoading: true,
      };
    }
    case types.CARD_ADD_SUCCESS: {
      return {
        ...state,
        cardAddError: null,
        cardAddResponse: action.payload,
        cardLoading: false,
      };
    }
    case types.CARD_ADD_FAILED: {
      return {
        ...state,
        cardAddError: action.payload,
        cardAddResponse: null,
        cardLoading: false,
      };
    }
    case types.FETCH_CARD_DETAILS: {
      return {
        ...state,
        loading: true,
        loaded: false,
        fetchCardError: null,
      };
    }
    case types.FETCH_CARD_DETAILS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        cardData: action.payload,
        fetchCardError: null,
      };
    }
    case types.FETCH_CARD_DETAILS_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        fetchCardError: action.payload,
      };
    }
    case types.CLEAR_CARD_DETAILS: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: null,
        cardData: null,
        fetchCardError: null,
        cardAddResponse: null,
        cardAddError: null,
      };
    }
    case types.CLEAR_CARD_ADD_ERROR: {
      return {
        ...state,
        cardAddError: null,
      };
    }
    case types.RESET_CURRENT_SIGUP_DETAILS: {
      return {
        ...state,
        successResponse: null,
        error: null,
      };
    }
    case types.RESET_CURRENT_LOGIN_DETAILS: {
      return {
        ...state,
        error: null,
      };
    }
    case types.CHANGE_USER_STATUS: {
      return {
        ...state,
        user: {
          ...state.user,
          customerAccountStatus: action.payload,
        },
      };
    }
    case types.UPDATE_AUTH_ROLE: {
      const sessionDetails = JSON.parse(
        localStorage.getItem("session_details"),
      );
      sessionDetails.roleName = action.payload;
      localStorage.setItem("session_details", JSON.stringify(sessionDetails));
      return {
        ...state,
        user: {
          ...state.user,
          roleName: action.payload,
        },
      };
    }
    case types.REGISTRATION_MESS_CLEAR:
      return {
        ...state,
        error: {},
      };
    case types.CLEAR_RESET_PASSWORD:
      return {
        ...state,
        error: null,
        forgot_response: null,
      };
    case types.CLEAR_AUTH:
      return {
        ...initialState,
      };
    case types.SOCIAL_SIGNUP: {
      return {
        ...state,
        loggingIn: true,
        error: null,
        socialLogin: true,
      };
    }
    case types.SOCIAL_SIGNUP_SUCCESS: {
      return {
        ...state,
        loggingIn: false,
        isLoggedIn: true,
        successResponse: action.payload,
        socialLogin: true,
      };
    }
    /* istanbul ignore next */
    case types.SOCIAL_SIGNUP_FAILED: {
      return {
        ...state,
        loggingIn: false,
        user: null,
        error: action.payload,
        successResponse: null,
        socialLogin: true,
      };
    }
    case types.REFRESH_HELP_SITE: {
      return {
        ...state,
        refreshHelpSiteSuccessMsg: null,
        refreshHelpSiteErrorMsg: null,
      };
    }
    case types.REFRESH_HELP_SITE_SUCCESS: {
      return {
        ...state,
        refreshHelpSiteSuccessMsg: action.payload,
        refreshHelpSiteErrorMsg: null,
      };
    }
    case types.REFRESH_HELP_SITE_FAILED: {
      return {
        ...state,
        refreshHelpSiteSuccessMsg: null,
        refreshHelpSiteErrorMsg: action.payload,
      };
    }
    case types.REFRESH_HELP_SITE_MSG_CLEAR: {
      return {
        ...state,
        refreshHelpSiteSuccessMsg: null,
        refreshHelpSiteErrorMsg: null,
      };
    }
    case types.CHECK_ELIGIBILITY_SSO: {
      return {
        ...state,
        isLoaded: true,
      };
    }
    case types.CHECK_ELIGIBILITY_SSO_SUCCESS: {
      return {
        ...state,
        isLoaded: false,
        ssoDetails: action.payload,
      };
    }
    case types.CHECK_ELIGIBILITY_SSO_FAILED: {
      return {
        ...state,
        isLoaded: false,
        ssoDetails: null,
        error: action.payload,
      };
    }

    case types.CLEAR_CHECK_ELIGIBILITY_SSO: {
      return {
        ...state,
        isLoaded: false,
        ssoDetails: null,
        error: null,
      };
    }

    case types.SSO_CALLBACK: {
      return {
        ...state,
        loggingIn: true,
        error: null,
        isLoading: true,
      };
    }
    case types.SSO_CALLBACK_SUCCESS: {
      return {
        ...state,
        ...(action.payload.data.jwt == null
          ? {
              isLoading: false,
              loggingIn: true,
              successResponse: action.payload,
            }
          : {
              isLoading: false,
              loggingIn: false,
              isLoggedIn: true,
              successResponse: action.payload,
            }),
      };
    }
    case types.SSO_CALLBACK_FAILED: {
      return {
        ...state,
        loggingIn: false,
        user: null,
        error: action.payload,
        successResponse: null,
        isLoading: false,
      };
    }
    case types.CLEAR_SSO_CALLBACK: {
      return {
        ...state,
        isLoggedIn: false,
        loggingIn: false,
        isLoading: false,
        user: null,
        successResponse: null,
        error: null,
      };
    }
    default:
      return state;
  }
}
